import React, { useEffect, useState } from "react";
import { settingService } from "../../../services/extensions";
import { timesheetApi } from "../../../services";
import { PickList } from "primereact/picklist";
import { Dropdown } from "primereact/dropdown";
import { toast } from "react-toastify";
import { Toolbar } from "primereact/toolbar";
import { MASTER_USERS_SUPERVISOR } from "../../../config/permissions";
import { hasPermission } from "../../../components/protected/ProtectedSection";
import { useSelector } from "react-redux";
import { selectUser } from "../../../services/store/userSlice";
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';

function UsersCategoryMapping() {
  const user = useSelector(selectUser);
  const empIndex = user.roles.indexOf('Masters Admin', 'Users Admin', 'ADMIN');
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [filterMasterCategory, setFilterMasterCategory] = useState([]);
  const [selProject, setSelProject] = useState([]);
  const [category, setCategory] = useState([]);
  const [selUser, setSelUser] = useState(null);
  const [masterCategory, setMasterCategory] = useState([]);
  const [selectedType, setSelectedType] = useState("");
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [editItemId, setEditItemId] = useState(null);
  const [inputValue, setInputValue] = useState('');
  let count = 0;

  useEffect(() => {
    if (count == 0) {
      getProjectsByUser();
      // getUsers(user?.id);
      getMasterCategory();
      count++;
    }
  }, []);
  
  useEffect(() => {
    if(selProject && selProject.id){
      getUsers(user?.id,selProject?.id);
  }
  }, [selProject.id]);

  const getProjectsByUser = () => {
    if (empIndex === 1) {
      settingService.getProjects().then(resp => {
        setProjects(resp.data.data);
      });
    } else {
      settingService.getProjectsByUser().then((resp) => {
        setProjects(resp.data.data);
      });
    }
  };

  const getMasterCategory = () => {
    settingService.getAllMasterCategory().then((resp) => {
      setMasterCategory(resp.data.data);
      setFilterMasterCategory(resp.data.data);
    });
  };

  const filterProject = (data) => {
    setSelectedProject(data.id);
    setSelUser(null);
    setSelProject(data);
  };

  const getUsers = (id = 0,selProject) => {
    const supervisor = hasPermission(MASTER_USERS_SUPERVISOR);
    let filter = {};
    if (supervisor && id != 0) {
      filter["superiorId"] = id;
    }
    let param ;
    param = {
      projectIds: [selProject]
    }

    // timesheetApi.getUsersBySuperior(filter).then((resp) => {
      settingService.getUsersByProjectId(param).then((resp) => {
      var userListing = [];
      var proUser = [];
      resp.data.data.map((item)=>{
        item.Allocations.map((items)=>{
          if(items.projectId ===selProject){
            proUser.push(item)
          }
          return items.projectId ===selProject;
        })
        return item.firstName
      });
      let proNameUnique = Array.from(new Set(proUser));
      proNameUnique.map((item) => {
        let objProject = {
          id: item.id,
          name: item.firstName.charAt(0).toUpperCase() + item.firstName.slice(1) + " " + item.lastName.charAt(0).toUpperCase() + item.lastName.slice(1),
        };
        userListing.push(objProject);
      });
      setUsers(userListing);
    });
  };

  const filterUser = (data) => {
    let userFilter;
    let projectFilter;
    setSelUser(data);
    const param = {
      projectId: selectedProject,
      status: 1,
    };
    settingService.getFilteredCategories(param).then((resp) => {
      projectFilter = resp.data.data.filter((item) => {
        return item.userId === null;
      });
      userFilter = resp.data.data.filter((item) => {
        return item.userId === data.id;
      });
      let matchedCategory = [...projectFilter, ...userFilter];
      let restMasterArray = filterMasterCategory.filter(
        ({ title: id1 }) =>
          !matchedCategory.some(({ title: id2 }) => id2 === id1)
      );
      setMasterCategory(restMasterArray);
      setCategory(userFilter);
    });
  };

  const itemBody = (item) => {
    return <span>{item.title}</span>;
  };

  const onChange = (event) => {
    if (selProject.length === 0 && selUser.length === 0) {
      toast.error("Please select Project and User!");
      return 1;
    } else if(selProject.length === 0){
      toast.error("Please select Project!");
      return 1;
    } else if(selUser.length === 0) {
      toast.error("Please select User!");
      return 1;
    }
    // moving all element source to target
    if (event.source.length === 0 && event.target.length !== 0) {
      var selectedSource = [];
      event.target.map((item) => {
        if (!item.projectId && !item.userId) {
          selectedSource.push(item);
        }
      });
      var proListing = [];
      selectedSource.map((item) => {
        let objProject = {
          projectId: selProject.id,
          userId: selUser.id,
          code: item.code,
          title: item.title,
        };
        proListing.push(objProject);
      });
      let param = proListing;
      settingService.addCategoryInBulk(param).then((resp) => {
        setMasterCategory(event.source);
        setCategory(event.target);
        filterProject(selProject);
        filterUser(selUser);
      });
      return true;
    }

    if (event.target.length === 0 && event.source.length !== 0) {
      const categoryIds = category.map((x) => {
        return x.id;
      });
      settingService.bulkDeleteCategoryById({ categoryIds }).then((resp) => {
        setMasterCategory(event.source);
        setCategory(event.target);
        filterProject(selProject);
        filterUser(selUser);
      });
      return true;
    }

    if (selProject.length !== 0 && selUser.length !== 0) {
      if (selectedType === "source") {
        // Add Category
        var proListing = [];
        selectedRowData.map((item) => {
          let objProject = {
            projectId: selProject.id,
            userId: selUser.id,
            code: item.code,
            title: item.title,
          };
          proListing.push(objProject);
        });
        let param = proListing;
        settingService.addCategoryInBulk(param).then((resp) => {
          setMasterCategory(event.source);
          setCategory(event.target);
          filterProject(selProject);
          filterUser(selUser);
        });
      }

      if (selectedType === "target") {
        const categoryIds = selectedRowData.map((x) => {
          return x.id;
        });
        settingService.bulkDeleteCategoryById({ categoryIds }).then((resp) => {
          setMasterCategory(event.source);
          setCategory(event.target);
          filterProject(selProject);
          filterUser(selUser);
        });
      }
    }
  };

  const onSourceSelectionChange = (e) => {
    setSelectedRowData(e.value);
    setSelectedType("source");
  };

  const onTargetSelectionChange = (e) => {
    setSelectedRowData(e.value);
    setSelectedType("target");
  };

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap', gap: '15px'}}>
          <div>
            <h3>Select Project</h3>
            <Dropdown filter id="projects_list" className="mb-3 mr-3" name="projects_list" options={projects} value={selProject} onChange={(e) => filterProject(e.value)} optionLabel="title" placeholder="Select Project" style={{minWidth: '180px'}} />

            <Dropdown filter id="projects_list" className="project_list" name="projects_list" options={projects} value={selProject} onChange={(e) => filterProject(e.value)} optionLabel="title" placeholder="Select Project" 
            style={{minWidth: '180px'}}
            />
          </div>
          <div>
            <h3>Select User</h3>
            <Dropdown id="users_list" name="users_list" className="users_list mb-3" options={users} value={selUser} onChange={(e) => filterUser(e.value)} optionLabel="name" filter showClear filterBy="name" placeholder="Select User" 
            style={{minWidth: '180px'}} 
            />
          </div>
        </div>
        
      </React.Fragment>
    );
  };

  const sourceTemplate = (item) => {
    return <span>{item.title}</span>;
  };

  const editTargetCategory = (itemId) => {
    setInputValue("");
    setEditItemId(itemId);
  }

  const saveTargetCategory = (itemToSave) => {
    if(inputValue < 1){
      toast.error("Value should be grater than equal to 1");
    } else {
      let param = {
        id: itemToSave.id,
        "projectId": itemToSave.projectId,
        "userId": itemToSave.userId,
        "code": itemToSave.code,
        "rate": inputValue,
        "title": itemToSave.title
      }
      settingService.updateCategoryRate(param).then((resp) => {
        if (resp) {
          filterUser(selUser);
          setEditItemId(null);
        }
      });
    }
  }
  
  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const targetTemplate = (item) => {
    return (
      <div id={`updateCatRate_${item.id}`}>
        <span>{item.title}</span>
        {editItemId === item.id && (
          <>
            <InputText name={`updateCatRate_${item.id}`} id={`updateCatRate_${item.id}`} style={{ width: '50px', borderRadius: '6px' }} value={inputValue} onChange={handleChange} className="ml-8" />
            <Button icon="pi pi-check" className="ml-2" rounded aria-label="Target" onClick={(e) => saveTargetCategory(item)} />
          </>
        )}
        {editItemId !== item.id && (
          <>
            <InputText style={{ width: '50px', borderRadius: '6px' }} className="ml-8" value={item.rate} disabled />
            <Button icon="pi pi-pencil" className="ml-2" rounded aria-label="Target" onClick={(e) => editTargetCategory(item.id)} />
          </>
        )}
      </div>
    );
  };

  return (
    <React.Fragment>
      <div>
        <Toolbar className="mb-2" left="" right={rightToolbarTemplate}></Toolbar>
      </div>
      <PickList
        source={masterCategory}
        target={category}
        // itemTemplate={itemBody}
        sourceItemTemplate={sourceTemplate}
        targetItemTemplate={targetTemplate}
        sourceHeader="Master Category"
        targetHeader="User Category"
        sourceStyle={{ height: "23.6vw" }}
        targetStyle={{ height: "23.6vw" }}
        onChange={onChange}
        onSourceSelectionChange={(e) => onSourceSelectionChange(e)}
        onTargetSelectionChange={(e) => onTargetSelectionChange(e)}
        className="col-8 col-offset-2"
        // style={{ marginLeft: "13vw" }}
        showSourceControls={false}
        showTargetControls={false}
      />
    </React.Fragment>
  );
}

export default UsersCategoryMapping;
